import {
  Box,
  Button,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const API_URL =
  "https://partner.instablood.org/partners.php";

const PartnersList = () => {
  const navigate = useNavigate();

  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ===== FETCH PARTNERS ===== */
  const fetchPartners = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await axios.get(API_URL);

      if (res.data?.success) {
        setPartners(res.data.data || []);
      } else {
        setError(res.data?.message || "Failed to load partners");
      }
    } catch (err) {
      console.error(err);
      setError("API error while fetching partners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  /* ===== HELPERS ===== */
  const capabilityLabel = (cap) => {
    if (cap === "BLOOD") return "Blood";
    if (cap === "AMBULANCE") return "Ambulance";
    return "Blood + Ambulance";
  };

  return (
    <Box>
      {/* ===== HEADER ===== */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5">Partners</Typography>

        <Button
          variant="contained"
          onClick={() => navigate("/partners/add")}
        >
          Add Partner
        </Button>
      </Box>

      {/* ===== LOADING ===== */}
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          py={6}
        >
          <CircularProgress />
        </Box>
      )}

      {/* ===== ERROR ===== */}
      {!loading && error && (
        <Typography color="error">
          {error}
        </Typography>
      )}

      {/* ===== TABLE ===== */}
      {!loading && !error && (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Partner Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Capability</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {partners.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                  >
                    No partners found
                  </TableCell>
                </TableRow>
              )}

              {partners.map((p) => (
                <TableRow key={p.id} hover>
                  <TableCell>
                    {p.partner_name}
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={p.partner_type}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={capabilityLabel(
                        p.capability
                      )}
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  </TableCell>

                  <TableCell>
                    {p.city}
                  </TableCell>

                  <TableCell>
                    <Chip
                      label="Active"
                      size="small"
                      color="success"
                    />
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    <Button
                      size="small"
                      onClick={() =>
                        navigate(
                          `/partners/${p.id}`
                        )
                      }
                    >
                      View
                    </Button>

                    {(p.capability === "AMBULANCE" ||
                      p.capability === "BOTH") && (
                      <Button
                        size="small"
                        onClick={() =>
                          navigate(
                            `/partners/${p.id}/ambulances/add`
                          )
                        }
                      >
                        Add Ambulance
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
};

export default PartnersList;
